import { Button, CardContent, DialogTitle, Divider, Grid, InputLabel, Stack, TextField } from '@mui/material';
import { PlayerFormDialogProps, PlayerFormValues } from './dto';
import { Form, FormikProvider, useFormik } from 'formik';
import { LoadingButton } from '@mui/lab';
import RequiredAsterisk from 'components/RequiredAsterisk';
import { usePlayerFormValidationSchema } from './hooks';

const PlayerFormDialog = ({ editMode, initialValues = {}, onCancel, onSubmit }: PlayerFormDialogProps) => {
    const validationSchema = usePlayerFormValidationSchema();
    const formik = useFormik<PlayerFormValues>({
        initialValues: {
            firstName: initialValues.firstName || '',
            lastName: initialValues.lastName || '',
            jerseyNumber: initialValues.jerseyNumber || undefined,
        },
        onSubmit: async (values) => {
            await onSubmit?.(values);
        },
        validationSchema,
    });

    const { handleSubmit, touched, dirty, errors, isValid, isSubmitting, getFieldProps } = formik;

    return (
        <FormikProvider value={formik}>
            <Form onSubmit={handleSubmit}>
                <DialogTitle>{editMode ? 'Update Player' : 'Add Player'}</DialogTitle>
                <CardContent>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Stack spacing={1}>
                                <InputLabel>
                                    First Name <RequiredAsterisk />
                                </InputLabel>
                                <TextField
                                    fullWidth
                                    id="firstName"
                                    placeholder="Enter First Name"
                                    error={touched.firstName && Boolean(errors.firstName)}
                                    helperText={touched.firstName && errors.firstName}
                                    {...getFieldProps('firstName')}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={12}>
                            <Stack spacing={1}>
                                <InputLabel>
                                    Last Name <RequiredAsterisk />
                                </InputLabel>
                                <TextField
                                    fullWidth
                                    id="lastName"
                                    placeholder="Enter Last Name"
                                    error={touched.lastName && Boolean(errors.lastName)}
                                    helperText={touched.lastName && errors.lastName}
                                    {...getFieldProps('lastName')}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={12}>
                            <Stack spacing={1}>
                                <InputLabel>Jersey Number</InputLabel>
                                <TextField
                                    fullWidth
                                    id="jerseyNumber"
                                    type="number"
                                    placeholder="Enter Jersey Number"
                                    error={touched.jerseyNumber && Boolean(errors.jerseyNumber)}
                                    helperText={touched.jerseyNumber && errors.jerseyNumber}
                                    {...getFieldProps('jerseyNumber')}
                                />
                            </Stack>
                        </Grid>
                    </Grid>
                </CardContent>
                <Divider />
                <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ px: 2.5, py: 2 }}>
                    <Button color="error" size="small" disabled={isSubmitting} onClick={onCancel}>
                        Cancel
                    </Button>
                    <LoadingButton
                        type="submit"
                        variant="contained"
                        size="small"
                        loading={isSubmitting}
                        disabled={!isValid || (!editMode && !dirty)}
                    >
                        Save
                    </LoadingButton>
                </Stack>
            </Form>
        </FormikProvider>
    );
};

export default PlayerFormDialog;
